import React, { FC } from 'react';
import { Type } from '@spotify-internal/encore-web';

type FieldLabelProps = {
  // This must match the id of the associated input/field
  htmlFor: string;
  className?: string;
};

export const FieldLabel: FC<FieldLabelProps> = ({
  htmlFor,
  className,
  children,
}) => (
  <Type
    as="label"
    htmlFor={htmlFor}
    className={className}
    weight="bold"
    semanticColor="textBase"
  >
    {children}
  </Type>
);
